import type { ChatCard } from "@cyh/contracts";
import { ShieldCheck } from "lucide-react";
import { OrderCard } from "./OrderCard";
import { useLanguage } from "../i18n";

export function ChatCardView({ card, busy, onConfirm, onOpenOrder }: { card: ChatCard; busy: boolean; onConfirm: (token: string) => void; onOpenOrder?: (orderNo: string) => void }) {
  const { t } = useLanguage();
  if (card.type === "order_progress") return <OrderCard order={card.order} onOpen={onOpenOrder} />;
  if (card.type === "confirmation") return <article className="confirm-card">
    <div className="confirm-card__heading"><ShieldCheck size={20} /><div><span className="eyebrow">{t("需要二次确认", "Confirmation required")}</span><h3>{card.title}</h3></div></div>
    <p>{card.summary}</p>
    <div className="confirm-actions"><button type="button" className="button secondary">{t("暂不修改", "Not now")}</button><button type="button" className="button primary" disabled={busy} onClick={() => onConfirm(card.token)}>{busy ? t("执行中…", "Processing…") : t("确认执行", "Confirm")}</button></div>
  </article>;
  if (card.type === "notice") return <div className={`notice ${card.tone}`}><strong>{card.title}</strong><span>{card.detail}</span></div>;
  return <div className="notice info"><strong>{t("流程信息", "Workflow information")}</strong><span>{t("已生成业务记录。", "A business record was created.")}</span></div>;
}
